import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() type: 'primary' | 'secondary' | 'warn' | 'error' | 'idle' | 'working' | 'accent' = 'primary';
  @Input() disabled = false;
  constructor() { }
}
